<template>
    <section class="abs ofh">
        <div class="first fl" v-if="action === 'compress'">
            <p class="fl">压缩参数：</p>
            <div class="fl cp" @click="compType='small'">
                <img :src="btnFocus('small')">缩小优先
            </div>
            <div class="fl cp" @click="compType='normal'">
                <img :src="btnFocus('normal')">常规压缩
            </div>
            <div class="fl cp" @click="compType='clear'">
                <img :src="btnFocus('clear')">清晰优先
            </div>
        </div>
        <div class="transform_param">
            <div v-if="action === 'transform'" class="fl">
                <label class="second">输出格式：</label>
                <select class="white2 bd1 br4 cp" v-model="out_format">
                    <option
                        :value="format.id"
                        v-for="format in out_format_options"
                        :key="format.id"
                    >{{format.name}}</option>
                </select>
            </div>
            <div>
                <label class="fl second">{{outTitle}}</label>
                <input
                    class="white2 bds bd1 brl fl"
                    type="text"
                    readonly="readonly"
                    :value="outPath"
                >
                <div class="fl brr last cp ct" @click="select_path">更改</div>
            </div>
            <div class="fr cp ct" @click="startAction" :class="{emptyFiles : emptyFiles == true}">开始转换</div>
        </div>
    </section>
</template>
<script>
import File from "../../mixin/File.js";
export default {
    name: "Bottom",
    mixins: [File],
    props: ['action','emptyFiles'],
    data: function () {
        return {
            outTitle: '保存路径：',
            compType: 'normal',
            outPath: window.os.homedir() + "\\Desktop",
            out_format_options: {
                1: { id: 1, name: 'png' },
                2: { id: 2, name: 'jpg' },
                3: { id: 3, name: 'bmp' },
                // 4: {id: 4, name: 'ico'},
                // 5: {id: 5, name: 'svg'},
            },
            out_format: 1,
            //emptyFiles: true,
        };
    },
    mounted() {
        this.$emit('receiveCompType', this.compType);
        this.$emit('receiveOutpath', this.outPath);
        this.$emit('receiveOutFormat', this.out_format);
    },
    methods: {
        btnFocus(type) {
            var same = type == this.compType;
            return 'img/gen/ico_' + (same ? 'xuanzhon' : 'weixuanzhon') + '.png';
        },
        /**
         * 选择路径
         */
        select_path: function () {
            let _this = this;
            _this.selectPath(function (path) {
                _this.outPath = path;
                //_this.$storage.set('transform_out_path', _this.outPath);
                _this.$emit('receiveOutpath', path);
            });
        },
        startAction: function () {
            //图片转换
            if ('transform' === this.action) {
                this.$emit('imageTransform');
            } else if ('compress' === this.action) {
                this.$emit('imageCompress');
            }

        },
    },
    watch: {
        compType: function () {
            this.$emit('receiveCompType', this.compType);
        },
        out_format: function () {
            this.$emit('receiveOutFormat', this.out_format);
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.emptyFiles{
    background: #CCCCCC !important;
}
section {
    height: 78px;
    left: 115px;
    right: 1px;
    bottom: 0px;
    border-top: 1px solid #e2e5ec;
}
.first,
.second {
    line-height: 20px;
    font-size: 12px;
    color: #464851;
}
.first {
    margin-left: 21px;
    margin-top: 33px;
}
.first img {
    padding-right: 5px;
    vertical-align: middle;
}
.first div {
    padding-right: 22px;
}
/* 路径 */
input {
    height: 25px;
    padding-left: 6px;
    font-size: 12px;
    color: #7a8c9c;
}
input.brl {
    width: 254px;
}
.brl {
    border-radius: 4px 0px 0px 4px;
}
.brr {
    height: 23px;
    border-radius: 0px 4px 4px 0px;
    border-right: 1px solid #e2e5ec;
    border-top: 1px solid #e2e5ec;
    border-bottom: 1px solid #e2e5ec;
}
.last {
    width: 42px;
    line-height: 22px;
    font-size: 12px;
    color: #7a8c9c;
}
.second {
    margin-left: 22px;
}
.transform_param {
    margin-top: 33px;
}
/* 开始转换 */
div.fr {
    margin-right: 21px;
    margin-top: -7px;
    width: 164px;
    height: 38px;
    line-height: 38px;
    font-size: 14px;
    color: white;
    border-radius: 19px;
    background: linear-gradient(-90deg, #10c375, #12c3a8);
}
div.fr:hover {
    background: #11c38a;
}
div.fr:active {
    background: #11c3a3;
}
/* 下拉菜单 */
.transform_param select {
    width: 297px;
    height: 25px;

    color: #7a8c9c;
}
select:focus {
    outline: none;
}
/* 下拉菜单 */
</style>